import { Row,Col, Card } from "antd";
import React from "react";
import ManagementSidebar from "./ManagementSidebar";


const ManagementLayout = ({children}) => {
  return (
    <div className="account-page">
      <Row gutter={16}>
        <Col lg={5}>
          <ManagementSidebar />
        </Col>
        <Col lg={19}>
          <div style={{height:'100%',borderRadius:'16px'}} >
          {children}
          </div>
        </Col>
      </Row>
    </div>
  );
};





export default ManagementLayout;
